export function handleErrors(response: Response): Promise<any> {
    if (response.status >= 200 && response.status < 300) {
        return response.json();
    }
    if (response.status === 403) {
        window.location.href = '/signin';
    }
    const error: any = new Error(response.statusText);
    error.response = response;
    throw error;
}

export const setCookie = (cookieKey: string, cookieValue: string | boolean | number, expirationDays?: number): void => {
    let expiryDate = '';
    if (expirationDays) {
        const date = new Date();
        date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
        expiryDate = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${cookieKey}=${encodeURIComponent(cookieValue ?? '')}${expiryDate}; path=/; SameSite=None; Secure`;
};

export const getCookie = (cookieKey: string): string | undefined => {
    const cookieName = `${cookieKey}=`;
    const cookieArray = document.cookie.split(';');
    for (let cookie of cookieArray) {
        cookie = cookie.trim();
        if (cookie.startsWith(cookieName)) {
            return decodeURIComponent(cookie.substring(cookieName.length));
        }
    }
    return undefined;
};

const CookieUtils = {
    handleErrors,
    setCookie,
    getCookie,
};

export default CookieUtils;